<report-page *ngIf="(device$ | async).targetSizes" [footer]="true" class="landscape">
    <div class="full-height full-width flex-column">
        <div class="full-width">
            <div class="strip bar-1"></div>
        </div>
        <div class="flex-row justify height-10">
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Report Time Interval : </strong></p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Begin: </strong>{{startDate|date:'medium'}}</p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>End: </strong>{{endDate|date:'medium'}}</p>
            </div>
        </div>
        <div *ngIf="(chartType$ | async) === 'line'">
            <figure *ngIf="customTimelineChartLines$ | async" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts" [constructorType]="'stockChart'"
                    [options]="customTimelineChartLines$ | async">
                </highcharts-chart>
            </figure>
            <hr />
            <figure *ngIf="customRangeTimelineChartLines$ | async" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts" [constructorType]="'stockChart'"
                    [options]="customRangeTimelineChartLines$ | async">
                </highcharts-chart>
            </figure>
        </div>
        <div *ngIf="(chartType$ | async) === 'series'">
            <figure *ngIf="customTimelineChartSeries$ | async" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                    [constructorType]="'stockChart'" [options]="customTimelineChartSeries$ | async">
                </highcharts-chart>
            </figure>
            <hr />
            <figure *ngIf="customRangeTimelineChartSeries$ | async" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts"
                    [constructorType]="'stockChart'" [options]="customRangeTimelineChartSeries$ | async">
                </highcharts-chart>
            </figure>
        </div>
        <div class="full-width">
            <div class="strip bar-1"></div>
            <div class="strip"></div>
            <div class="strip"></div>
        </div>
    </div>
</report-page>